import m from 'mithril'
import moment from 'moment'
import {
    Dialog,
    TextBox
} from 'components'
import * as Components from 'components'
import Uploader from 'components/uploader/core'
import {
    Article
} from 'app/models'
import classNames from 'classnames';
import {
    Paging,
} from 'components'
import ArticleDetailModal from './dialogs/articleDetail'




export default class ArticlePage {
    constructor() {
        window.search_keyword = ""
        Article.pageIndex = 1
        window.article_type = "最新圖片"
        Article.getArticleLastList()
        this.types = ["最新圖片", "最新文章"]
    }
    view() {
        return [
            m(".row",
                m(".col-xl-12",
                    m(".breadcrumb-holder", [
                        m("h3.main-title.float-left", `文章列表`),
                        m("ol.breadcrumb.float-right",
                            [
                                m("li.breadcrumb-item.active", `文章列表/首頁`)
                            ]
                        ), m(".clearfix")
                    ])
                )
            ),
            m(".row.d-flex.justify-content-center",
                m(".col-md-11",
                    m(".panel-content",
                        m(".card.mb-3",
                            [
                                m(".card-header",
                                    m(".row.d-flex.justify-content-between.align-items-center", [
                                        m(".col-2",
                                            m("h3", [m("i.fa.fa-table.mr-2"), "文章列表"]),
                                        ),
                                        m(".col-7", [
                                            m(".row.d-flex.justify-content-end.align-items-center", [

                                                this.types.map((_type) => {
                                                    return m(".col.d-flex.justify-content-end.align-items-center.p-1", {
                                                        style: {

                                                        },
                                                        onclick: (e) => {
                                                            e.preventDefault()
                                                            window.article_type = _type
                                                            Article.pageIndex = 1
                                                            Article.getArticleLastList()
                                                        }
                                                    }, [
                                                        m(".btn.w-100", {
                                                            style: {
                                                                backgroundColor: (window.article_type == _type) ? "#252525" : "#EAEAEA",
                                                                color: (window.article_type == _type) ? "#FFFFFF" : "#252525",
                                                                borderRadius: "15px",
                                                                fontSize: "1rem"
                                                            }
                                                        }, _type)
                                                    ])
                                                })
                                            ])
                                        ])

                                    ])
                                ),
                                m(".card-header", [
                                    // (window.article_type == "最新圖片") ? [
                                    //     m(".row.w-100.text-light.border-bottom.pb-1", [

                                    //     ])

                                    // ] :
                                    //     m(".row.w-100.text-light.border-bottom.pb-1", [
                                    //         m(".col-1",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "ID")
                                    //         ),
                                    //         m(".col-1"),
                                    //         m(".col-2",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "暱稱")
                                    //         ),
                                    //         m(".col-1",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "使用點數")
                                    //         ),
                                    //         m(".col-1",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "剩餘點數")
                                    //         ),
                                    //         m(".col-1",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "文章數")
                                    //         ),
                                    //         m(".col-1",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "圖片數")
                                    //         ),
                                    //         m(".col-1",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "加入時間")
                                    //         ),
                                    //         m(".col-3",
                                    //             m("span.font-weight-bold", {
                                    //                 style: {
                                    //                     color: "#4c73b4"
                                    //                 }
                                    //             }, "功能")
                                    //         ),


                                    //     ]),

                                    (Article.loading) ?
                                        [
                                            m(".row.w-100.text-dark.border-bottom.align-items-center.py-2", {
                                                style: {
                                                    fontSize: "85%",
                                                    fontWeight: 700,
                                                    lineHeight: 1,
                                                }
                                            }, [
                                                m('.col-12.text-center.py-2', [
                                                    m('span', {
                                                        style: {
                                                            fontSize: "1.5rem"
                                                        }
                                                    }, "資料讀取中...")
                                                ])
                                            ])

                                        ] : [
                                            (Article.data.length == 0) ?
                                                [
                                                    m(".row.w-100.text-dark.border-bottom.align-items-center.py-2", {
                                                        style: {
                                                            fontSize: "85%",
                                                            fontWeight: 700,
                                                            lineHeight: 1,
                                                        }
                                                    }, [
                                                        m('.col-12.text-center.py-2', [
                                                            m('span', {
                                                                style: {
                                                                    fontSize: "1.5rem"
                                                                }
                                                            }, "無資料")
                                                        ])
                                                    ])

                                                ] : [
                                                    (window.article_type == "最新圖片") ? [
                                                        m(".row.w-100.text-dark.border-bottom.align-items-center.py-2", [
                                                            Article.data.map((_data, index) => {
                                                                return [

                                                                    m(".col-3.p-1", [
                                                                        m(".row", [
                                                                            m(".col-6", [
                                                                                m("div.img-fluid", {
                                                                                    style: {
                                                                                        height: "180px",
                                                                                        width: "180px",
                                                                                        maxHeight: "180px",
                                                                                        maxWidth: "180px",
                                                                                        backgroundImage: `url("${_data.articles[0].url}")`,
                                                                                        backgroundRepeat: "no-repeat",
                                                                                        backgroundPosition: "center",
                                                                                        backgroundSize: "cover",
                                                                                        border: "1px solid #EFEFEF",
                                                                                        borderRadius: "5px",
                                                                                        cursor: "pointer",
                                                                                    },
                                                                                    onclick: (e) => {
                                                                                        e.preventDefault()
                                                                                        e.stopPropagation()
                                                                                        Dialog.show(ArticleDetailModal, {
                                                                                            attrs: {
                                                                                                model: _data,
                                                                                            },
                                                                                        })
                                                                                    }
                                                                                })
                                                                            ]),
                                                                            m(".col-6", [
                                                                                m(".row", [
                                                                                    m(".col-12",[
                                                                                        m("span.font-weight-bold", { style: { "font-size": "1.15rem" } }, _data.model_name)
                                                                                    ]),
                                                                                    m(".col-12", [
                                                                                        m("span", _data.user.nickname)
                                                                                    ]),
                                                                                    m(".col-12", [
                                                                                        m("span", moment(_data.created_at).format("YYYYMMDD"))
                                                                                    ]),
                                                                                ])
                                                                            ])
                                                                        ])
                                                                    ])
                                                                ]
                                                            })
                                                        ])
                                                    ] : [

                                                        Article.data.map((_data, index) => {
                                                            return m(".row.w-100.text-dark.border-bottom.align-items-center.py-2", {
                                                                style: {
                                                                    // fontSize: "85%",
                                                                    fontWeight: 700,
                                                                    lineHeight: 1,
                                                                    backgroundColor: (index % 2 == 0) ? "#f2f2f2" : "#FFF"
                                                                },
                                                                onclick: (e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                    Dialog.show(ArticleDetailModal, {
                                                                        attrs: {
                                                                            model: _data,
                                                                        },
                                                                    })
                                                                }
                                                            }, [
                                                                m(".col-1",
                                                                    m("span", _data.id)
                                                                ),
                                                                m(".col-2",
                                                                    m("div.img-fluid.rounded-circle", {
                                                                        style: {
                                                                            height: "60px",
                                                                            width: "60px",
                                                                            maxHeight: "60px",
                                                                            maxWidth: "60px",
                                                                            backgroundImage: `url("${_data.user.profile}")`,
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center",
                                                                            backgroundSize: "cover",
                                                                            border: "1px solid #000000",
                                                                            cursor: "pointer",
                                                                        },
                                                                    })
                                                                ),
                                                                m(".col-2",
                                                                    m("span", _data.user.nickname)
                                                                ),
                                                                m(".col-1",
                                                                    m("span", _data.model_name)
                                                                ),
                                                                m(".col-1",
                                                                    m("span", moment(_data.created_at).format("YYYYMMDD"))
                                                                ),
                                                                m(".col-3",
                                                                    m("button.btn.btn-sm.mx-0.mx-md-1.my-1.my-md-0.px-2", {
                                                                        style: {
                                                                            backgroundColor: "#e2f0d9"
                                                                        },
                                                                        onclick: (e) => {
                                                                            e.preventDefault()
                                                                            e.stopPropagation()
                                                                            Dialog.show(ArticleDetailModal, {
                                                                                attrs: {
                                                                                    model: _data,
                                                                                },
                                                                            })
                                                                        }
                                                                    },
                                                                        [
                                                                            m("i.fa.fa-eye"),
                                                                            m("span.pl-2", "詳細")
                                                                        ]
                                                                    ),
                                                                ),

                                                            ])

                                                        }),
                                                    ],

                                                ]
                                        ],
                                    m('.row.no-gutters.px-5', [
                                        m('.col-12.pt-3', [
                                            m('.d-flex.flex-sm-row.flex-column.justify-content-md-between', [
                                                m(Paging.Pagination, {
                                                    pageNo: Article.paging.pageNo,
                                                    pageCount: Article.paging.pageCount,
                                                    pageUrl: Article.getArticleLastList.bind(this)
                                                }),
                                                m(Paging.PageItemCount, {
                                                    pageNo: Article.paging.pageNo,
                                                    pageSize: Article.paging.pageSize,
                                                    total: Article.paging.totalRecordCount
                                                })
                                            ])
                                        ])
                                    ]),
                                ]),
                            ]
                        )
                    )
                )
            ),
        ]
    }
}